// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page {
  min-height: 100vh;
  background: transparent;
  position: relative;
}

/* Fixed background image for settings page */
.settings-page::after {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--background-image, none);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: var(--color-primary);
  background-blend-mode: multiply;
  background-attachment: fixed;
  pointer-events: none;
  z-index: -1;
}

/* Gradient overlay for settings page */
.settings-page::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--color-gradient-start) 0%, var(--color-gradient-end) 100%);
  opacity: 0.2;
  pointer-events: none;
  z-index: 0;
}

.settings-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
}

.settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.settings-header h2 {
  margin: 0;
  color: var(--color-text-on-background);
  font-size: 2rem;
}

.save-changes-btn {
  padding: 0.75rem 1.5rem;
  background: var(--color-success);
  color: var(--color-button-text);
  border: none;
  border-radius: 9999px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
}

.save-changes-btn:hover:not(:disabled) {
  background: var(--color-success-hover);
  box-shadow: 0 4px 8px rgba(16, 185, 129, 0.3);
  transform: translateY(-1px);
}

.save-changes-btn:disabled {
  background: var(--color-text-secondary);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.settings-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
  border-bottom: 2px solid var(--color-border-light);
  background: var(--color-card-bg);
  padding: 0.5rem;
  border-radius: 0.5rem 0.5rem 0 0;
}

.settings-tabs button {
  padding: 1rem 2rem;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  color: var(--color-text-secondary);
  transition: all 0.2s;
}

.settings-tabs button:hover {
  color: var(--color-primary);
  border-bottom-color: #93c5fd;
}

.settings-tabs button.active {
  color: var(--color-primary);
  border-bottom-color: var(--color-primary);
}

.settings-content {
  background: var(--color-card-bg);
  border-radius: 0.75rem;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.settings-section h3 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  color: var(--color-text);
  font-size: 1.5rem;
}

.section-description {
  color: var(--color-text-secondary);
  margin-bottom: 2rem;
  font-size: 0.95rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: var(--color-text-muted);
  font-size: 0.95rem;
}

.form-group input[type="text"],
.form-group input[type="email"],
.form-group input[type="tel"],
.form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: all 0.2s;
  background: var(--color-input-bg);
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: var(--color-input-focus);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.readonly-field {
  background: var(--color-background) !important;
  color: var(--color-text-secondary) !important;
  cursor: not-allowed !important;
}

.field-description {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  color: var(--color-text-secondary);
}

/* Profile Headshot Section */
.profile-headshot-section {
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--color-border-light);
}

.profile-headshot-section > label {
  display: block;
  margin-bottom: 1rem;
  font-weight: 600;
  color: var(--color-text-muted);
  font-size: 0.95rem;
}

.headshot-container {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.headshot-preview {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  background: var(--color-border-light);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 3px solid var(--color-border);
}

.headshot-placeholder {
  font-size: 4rem;
  font-weight: bold;
  color: var(--color-text-secondary);
}

.headshot-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1 1;
}

.headshot-actions button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 9999px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-upload {
  background: var(--color-primary);
  color: var(--color-button-text);
}

.btn-upload:hover:not(:disabled) {
  background: var(--color-primary-hover);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
}

.btn-upload:disabled {
  background: var(--color-text-secondary);
  cursor: not-allowed;
}

.btn-remove {
  background: var(--color-danger);
  color: var(--color-button-text);
}

.btn-remove:hover:not(:disabled) {
  background: var(--color-danger-hover);
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
}

.btn-remove:disabled {
  background: var(--color-text-secondary);
  cursor: not-allowed;
}

.upload-hint {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  margin: 0;
}

/* Checkbox Groups (legacy - kept for any remaining usage) */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.2s;
}

.checkbox-label:hover {
  background: var(--color-background);
}

.checkbox-label input[type="checkbox"] {
  width: 1.25rem;
  height: 1.25rem;
  cursor: pointer;
  margin-top: 0.25rem;
  flex-shrink: 0;
}

.checkbox-label > div {
  flex: 1 1;
}

.checkbox-label span {
  display: block;
  font-weight: 600;
  color: var(--color-text-muted);
  margin-bottom: 0.25rem;
}

.checkbox-description {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  margin: 0;
}

/* Share Management Buttons */
.btn-remove-share {
  padding: 0.625rem 1.25rem;
  background: var(--color-danger);
  color: var(--color-button-text);
  border: none;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-remove-share:hover {
  background: var(--color-danger-hover);
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
  transform: translateY(-1px);
}

/* Modal Buttons */
.modal-buttons {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

.btn-cancel,
.btn-continue {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 9999px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel {
  background: var(--color-border);
  color: var(--color-text);
}

.btn-cancel:hover {
  background: var(--color-border-light);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-continue {
  background: var(--color-danger);
  color: var(--color-button-text);
}

.btn-continue:hover {
  background: var(--color-danger-hover);
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
}

/* Responsive */
@media (max-width: 768px) {
  .settings-container {
    padding: 1rem;
  }

  .settings-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .save-changes-btn {
    width: 100%;
  }

  .settings-tabs {
    overflow-x: auto;
  }

  .settings-tabs button {
    padding: 0.75rem 1.5rem;
    white-space: nowrap;
  }

  .settings-content {
    padding: 1.5rem;
  }

  .headshot-container {
    flex-direction: column;
    align-items: center;
  }

  .headshot-actions {
    width: 100%;
  }
}

/* Settings Row - left/right layout for all settings */
.settings-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  gap: 1.5rem;
}

.settings-row + .settings-row {
  border-top: 1px solid var(--color-border-light);
}

.settings-row-info {
  flex: 1 1;
  min-width: 0;
}

.settings-row-label {
  font-weight: 600;
  color: var(--color-text-muted);
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}

.settings-row-description {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.4;
}

.settings-row-control {
  flex-shrink: 0;
}

.settings-row-control select {
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 0.5rem;
  background: var(--color-input-bg);
  color: var(--color-text);
  font-size: 0.95rem;
  min-width: 160px;
}

.settings-row-control select:focus {
  outline: none;
  border-color: var(--color-input-focus);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.settings-row-control select:disabled {
  background: var(--color-background-secondary);
  color: var(--color-text-secondary);
  cursor: not-allowed;
}

/* Toggle Switch */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
  flex-shrink: 0;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.toggle-switch-track {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--color-border);
  transition: 0.3s;
  border-radius: 26px;
}

.toggle-switch-track.active {
  background-color: var(--color-primary);
}

.toggle-switch-track.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.toggle-switch-knob {
  position: absolute;
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.toggle-switch-knob.active {
  left: 27px;
}

/* Settings section divider */
.settings-section-divider {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--color-border);
}

.settings-section-divider h4 {
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  color: var(--color-heading);
}

.settings-section-divider > p {
  margin-bottom: 1rem;
  color: var(--color-text-secondary);
  font-size: 0.9rem;
  line-height: 1.5;
}

/* Disabled settings row */
.settings-row.disabled {
  opacity: 0.6;
}

/* Responsive settings rows */
@media (max-width: 480px) {
  .settings-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .settings-row-control {
    align-self: flex-end;
  }

  .settings-row-control select {
    min-width: 140px;
  }
}

/* Password input error state */
.password-error .password-input {
  border: 1px solid var(--color-danger);
}
`, "",{"version":3,"sources":["webpack://./src/SettingsPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+CAA+C;EAC/C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;EACpB,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mGAAmG;EACnG,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,+BAA+B;EAC/B,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kDAAkD;EAClD,gCAAgC;EAChC,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;;EAEE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,8CAA8C;EAC9C,6CAA6C;EAC7C,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,SAAS;AACX;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,qBAAqB;EACrB,iCAAiC;EACjC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,+BAA+B;AAC/B;EACE,qCAAqC;AACvC","sourcesContent":[".settings-page {\n  min-height: 100vh;\n  background: transparent;\n  position: relative;\n}\n\n/* Fixed background image for settings page */\n.settings-page::after {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: var(--background-image, none);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: var(--color-primary);\n  background-blend-mode: multiply;\n  background-attachment: fixed;\n  pointer-events: none;\n  z-index: -1;\n}\n\n/* Gradient overlay for settings page */\n.settings-page::before {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, var(--color-gradient-start) 0%, var(--color-gradient-end) 100%);\n  opacity: 0.2;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.settings-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.settings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.settings-header h2 {\n  margin: 0;\n  color: var(--color-text-on-background);\n  font-size: 2rem;\n}\n\n.save-changes-btn {\n  padding: 0.75rem 1.5rem;\n  background: var(--color-success);\n  color: var(--color-button-text);\n  border: none;\n  border-radius: 9999px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);\n}\n\n.save-changes-btn:hover:not(:disabled) {\n  background: var(--color-success-hover);\n  box-shadow: 0 4px 8px rgba(16, 185, 129, 0.3);\n  transform: translateY(-1px);\n}\n\n.save-changes-btn:disabled {\n  background: var(--color-text-secondary);\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n.settings-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n  border-bottom: 2px solid var(--color-border-light);\n  background: var(--color-card-bg);\n  padding: 0.5rem;\n  border-radius: 0.5rem 0.5rem 0 0;\n}\n\n.settings-tabs button {\n  padding: 1rem 2rem;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  transition: all 0.2s;\n}\n\n.settings-tabs button:hover {\n  color: var(--color-primary);\n  border-bottom-color: #93c5fd;\n}\n\n.settings-tabs button.active {\n  color: var(--color-primary);\n  border-bottom-color: var(--color-primary);\n}\n\n.settings-content {\n  background: var(--color-card-bg);\n  border-radius: 0.75rem;\n  padding: 2rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.settings-section h3 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  color: var(--color-text);\n  font-size: 1.5rem;\n}\n\n.section-description {\n  color: var(--color-text-secondary);\n  margin-bottom: 2rem;\n  font-size: 0.95rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n  font-size: 0.95rem;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"email\"],\n.form-group input[type=\"tel\"],\n.form-group select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  transition: all 0.2s;\n  background: var(--color-input-bg);\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: var(--color-input-focus);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.readonly-field {\n  background: var(--color-background) !important;\n  color: var(--color-text-secondary) !important;\n  cursor: not-allowed !important;\n}\n\n.field-description {\n  margin-top: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n}\n\n/* Profile Headshot Section */\n.profile-headshot-section {\n  margin-bottom: 2rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid var(--color-border-light);\n}\n\n.profile-headshot-section > label {\n  display: block;\n  margin-bottom: 1rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n  font-size: 0.95rem;\n}\n\n.headshot-container {\n  display: flex;\n  gap: 2rem;\n  align-items: flex-start;\n}\n\n.headshot-preview {\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  overflow: hidden;\n  background: var(--color-border-light);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border: 3px solid var(--color-border);\n}\n\n.headshot-placeholder {\n  font-size: 4rem;\n  font-weight: bold;\n  color: var(--color-text-secondary);\n}\n\n.headshot-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  flex: 1;\n}\n\n.headshot-actions button {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 9999px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-upload {\n  background: var(--color-primary);\n  color: var(--color-button-text);\n}\n\n.btn-upload:hover:not(:disabled) {\n  background: var(--color-primary-hover);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);\n}\n\n.btn-upload:disabled {\n  background: var(--color-text-secondary);\n  cursor: not-allowed;\n}\n\n.btn-remove {\n  background: var(--color-danger);\n  color: var(--color-button-text);\n}\n\n.btn-remove:hover:not(:disabled) {\n  background: var(--color-danger-hover);\n  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);\n}\n\n.btn-remove:disabled {\n  background: var(--color-text-secondary);\n  cursor: not-allowed;\n}\n\n.upload-hint {\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* Checkbox Groups (legacy - kept for any remaining usage) */\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.checkbox-label:hover {\n  background: var(--color-background);\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 1.25rem;\n  height: 1.25rem;\n  cursor: pointer;\n  margin-top: 0.25rem;\n  flex-shrink: 0;\n}\n\n.checkbox-label > div {\n  flex: 1;\n}\n\n.checkbox-label span {\n  display: block;\n  font-weight: 600;\n  color: var(--color-text-muted);\n  margin-bottom: 0.25rem;\n}\n\n.checkbox-description {\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* Share Management Buttons */\n.btn-remove-share {\n  padding: 0.625rem 1.25rem;\n  background: var(--color-danger);\n  color: var(--color-button-text);\n  border: none;\n  border-radius: 9999px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-remove-share:hover {\n  background: var(--color-danger-hover);\n  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Modal Buttons */\n.modal-buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n}\n\n.btn-cancel,\n.btn-continue {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 9999px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-cancel {\n  background: var(--color-border);\n  color: var(--color-text);\n}\n\n.btn-cancel:hover {\n  background: var(--color-border-light);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.btn-continue {\n  background: var(--color-danger);\n  color: var(--color-button-text);\n}\n\n.btn-continue:hover {\n  background: var(--color-danger-hover);\n  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .settings-container {\n    padding: 1rem;\n  }\n\n  .settings-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .save-changes-btn {\n    width: 100%;\n  }\n\n  .settings-tabs {\n    overflow-x: auto;\n  }\n\n  .settings-tabs button {\n    padding: 0.75rem 1.5rem;\n    white-space: nowrap;\n  }\n\n  .settings-content {\n    padding: 1.5rem;\n  }\n\n  .headshot-container {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .headshot-actions {\n    width: 100%;\n  }\n}\n\n/* Settings Row - left/right layout for all settings */\n.settings-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 0;\n  gap: 1.5rem;\n}\n\n.settings-row + .settings-row {\n  border-top: 1px solid var(--color-border-light);\n}\n\n.settings-row-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.settings-row-label {\n  font-weight: 600;\n  color: var(--color-text-muted);\n  font-size: 0.95rem;\n  margin-bottom: 0.25rem;\n}\n\n.settings-row-description {\n  font-size: 0.875rem;\n  color: var(--color-text-secondary);\n  margin: 0;\n  line-height: 1.4;\n}\n\n.settings-row-control {\n  flex-shrink: 0;\n}\n\n.settings-row-control select {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 0.5rem;\n  background: var(--color-input-bg);\n  color: var(--color-text);\n  font-size: 0.95rem;\n  min-width: 160px;\n}\n\n.settings-row-control select:focus {\n  outline: none;\n  border-color: var(--color-input-focus);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.settings-row-control select:disabled {\n  background: var(--color-background-secondary);\n  color: var(--color-text-secondary);\n  cursor: not-allowed;\n}\n\n/* Toggle Switch */\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 26px;\n  flex-shrink: 0;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n\n.toggle-switch-track {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--color-border);\n  transition: 0.3s;\n  border-radius: 26px;\n}\n\n.toggle-switch-track.active {\n  background-color: var(--color-primary);\n}\n\n.toggle-switch-track.disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.toggle-switch-knob {\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\n.toggle-switch-knob.active {\n  left: 27px;\n}\n\n/* Settings section divider */\n.settings-section-divider {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.settings-section-divider h4 {\n  margin-bottom: 0.5rem;\n  font-size: 1.1rem;\n  color: var(--color-heading);\n}\n\n.settings-section-divider > p {\n  margin-bottom: 1rem;\n  color: var(--color-text-secondary);\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n/* Disabled settings row */\n.settings-row.disabled {\n  opacity: 0.6;\n}\n\n/* Responsive settings rows */\n@media (max-width: 480px) {\n  .settings-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .settings-row-control {\n    align-self: flex-end;\n  }\n\n  .settings-row-control select {\n    min-width: 140px;\n  }\n}\n\n/* Password input error state */\n.password-error .password-input {\n  border: 1px solid var(--color-danger);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
